import React, { useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberCompetencyForm from '../../../components/forms/MemberCompetencyForm';
import { useMemberCompetencyApi } from '../../../hooks/useMemberCompetencyApi';
import { useNavigate } from 'react-router-dom';
import { MemberCompetencyDTO } from '../../../services/apiClient';

const MemberCompetencyCreate: React.FC = () => {
  const { create, createBulk, isLoading } = useMemberCompetencyApi();
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Competencies', href: '/admin/membercompetencies' },
    { label: 'Create', href: '#' },
  ];

  const handleSubmit = async (data: MemberCompetencyDTO, competencyTypeIds?: string[]) => {
    try {
      setIsSubmitting(true);

      if (competencyTypeIds && competencyTypeIds.length > 1) {
        const records = competencyTypeIds.map((competencyTypeId) => ({
          ...data,
          competencyTypeId,
        }));
        await createBulk(records);
      } else {
        await create({ ...data, competencyTypeId: competencyTypeIds?.[0] ?? data.competencyTypeId });
      }

      navigate('/admin/membercompetencies');
    } catch (error) {
      console.error('Error creating MemberCompetency:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/membercompetencies"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin', 'User']}
      requiredPermission="Manage.MemberCompetency.Edit"
    >
      <MemberCompetencyForm
        initialValues={{} as MemberCompetencyDTO}
        onSubmit={handleSubmit}
        onCancel={() => navigate('/admin/membercompetencies')}
        isLoading={isSubmitting}
      />
    </AdminLayout>
  );
};

export default MemberCompetencyCreate;
